export const getErrorMessageBannerStyles = () => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: 69,
    border: '1px solid #D1D1D1',
    borderRadius: 4,
    background: '#F5F5F5',
    margin: '0 48px 48px 48px',
  },
  'container-l': {
    height: 50,
  },
  'container-m': {
    height: 50,
  },
  'container-s': {
    height: 50,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
    height: '100%',
  },
  errorText: {
    marginRight: '20px',
    color: '#424242',
    fontSize: '16px',
    lineHeight: '18px',
  },
  'errorText-l': {
    fontSize: '14px',
    lineHeight: '18px',
  },
  'errorText-m': {
    fontSize: '12px',
    lineHeight: '16px',
  },
  'errorText-s': {
    fontSize: '12px',
    lineHeight: '16px',
  },
});
